import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { Podcast } from './types'

export const PODCASTS_QUERY: TypedDocumentNode<
  { podcasts: Podcast[] },
  { clientId: string; applicationId: string; search?: string; limit?: number; offset?: number }
> = gql`
  query Podcasts($clientId: ID!, $applicationId: ID!, $search: String, $limit: Int, $offset: Int) {
    podcasts(clientId: $clientId, applicationId: $applicationId, search: $search, limit: $limit, offset: $offset) {
      id client_id application_id name embedded_link description observations synchronized_at created_at updated_at
    }
  }
`

export const PODCAST_QUERY: TypedDocumentNode<{ podcast: Podcast | null }, { id: string }> = gql`
  query Podcast($id: ID!) {
    podcast(id: $id) {
      id client_id application_id name embedded_link description observations synchronized_at created_at updated_at
    }
  }
`
